import type { PriceEnhancement } from '../trades/trades.model';
import type { PriceEnhancementsMap } from './priceEnhancements.model';

export function getPriceEnhancement(
  state: PriceEnhancementsMap,
  quoteId: string | undefined,
): Partial<PriceEnhancement> | undefined {
  return quoteId ? state[quoteId] : undefined;
}
